import "./styles/style.css"
import React from "react";
import { Field } from "./components/Field";

export default function App(){
    return (
    <div className="app-wrap">
        <Field />
    </div>
    );
}